var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.signOut.apply(null, arguments)}}},[_vm._t("default",function(){return [_vm._v("Sign Out")]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }